import {
  CONFIGURATION_USERS_FETCH_DATA,
  CONFIGURATION_USERS_FETCH_SUCCESS,
  DELETE_USERS_REQUEST,
  DELETE_USERS_SUCCESS,
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  CLEAR_USER,
  SAVE_USER_REQUEST,
  SAVE_USER_SUCCESS,
  CONFIGURATION_USERS_FETCH_ACCESS_DATA,
  CONFIGURATION_USERS_FETCH_ACCESS_SUCCESS,
  SAVE_PERMISSIONS_REQUEST,
  SAVE_PERMISSIONS_SUCCESS,
  FETCH_IMPERSONATE_TOKEN,
  FETCH_IMPERSONATE_TOKEN_SUCCESS,
  CLEAR_LOADING,
  FETCH_OWN_PROFILE_REQUEST,
  FETCH_OWN_PROFILE_SUCCESS,
  ACTIVATE_USER_REQUEST,
  ACTIVATE_USER_SUCCESS,
  UPLOAD_USER_DOCUMENT_REQUEST,
  UPLOAD_USER_DOCUMENT_SUCCESS,
  RESET_USER_PASSWORD,
  RESET_USER_PASSWORD_SUCCESS,
  CHANGE_USER_PASSWORD,
  CHANGE_USER_PASSWORD_SUCCESS,
  FETCH_USER_GRANT_REQUEST,
  FETCH_USER_GRANT_REQUEST_SUCCESS,
  SAVE_USERS_GRANTS_REQUEST,
  SAVE_USERS_GRANTS_REQUEST_SUCCESS,
  FETCH_UPLOAD_LOGS_REQUEST,
  FETCH_UPLOAD_LOGS_SUCCESS,
  FETCH_DETAILED_REPORT_REQUEST,
  USER_PROGRAMS_LISTING_REQUEST,
  USER_PROGRAMS_LISTING_SUCCESS,
  USER_PROGRAMS_LISTING_RESET,
  EXCLUDED_FACILITIES_REQUEST,
  EXCLUDED_FACILITIES_SUCCESS,
  FETCH_USER_PREFERENCES_REQUEST,
  FETCH_USER_PREFERENCES_SUCCESS,
  SAVE_USER_PREFERENCES_REQUEST,
  SAVE_USER_PREFERENCES_SUCCESS,
} from '@constants/UHEActionTypes';

/**
 * Fetch own user profile
 * @return {Object} object
 */
export const onFetchOwnPofile = () => ({
  type: FETCH_OWN_PROFILE_REQUEST,
});

/**
 * Fetch own user profile
 * @param {Object} data data
 * @return {Object} object
 */
export const onFetchOwnPofileSuccess = (data) => ({
  type: FETCH_OWN_PROFILE_SUCCESS,
  payload: data,
});

/**
 * Fetch system data
 * @param  {number} page page
 * @param  {string} sorting sorting
 * @param  {string} filter filter
 * @return {Object} object
 */
export const usersOnFetchData = (page, sorting, filter) => ({
  type: CONFIGURATION_USERS_FETCH_DATA,
  page,
  sorting,
  filter,
});

/**
 * Fetch success
 * @param  {Object} data data
 * @return {Object} object
 */
export const fetchUsersDataSuccess = (data) => ({
  DELETE_USERS_SUCCESS,
  type: CONFIGURATION_USERS_FETCH_SUCCESS,
  data,
});

/**
 * DELETE request
 * @param {Object} data data
 * @return {Promise} promise
 */
export const deleteUser = (data) => ({
  type: DELETE_USERS_REQUEST,
  payload: data,
});

/**
 * DELETE request success
 * @param {Object} data data
 * @return {Promise} promise
 */
export const deleteUserSuccess = (data) => ({
  type: DELETE_USERS_SUCCESS,
  payload: data,
});

/**
 * Handle FETCH_USER_REQUEST Action
 * @param {Object} payload payload
 * @returns {Object} object
 */
export const fetchUser = (payload) => ({
  type: FETCH_USER_REQUEST,
  id: payload.id,
});

/**
 * Handle FETCH_USER_SUCCESS Action
 * @param {Object} payload payload
 * @returns {Object} object
 */
export const fetchUserSuccess = (payload) => ({
  type: FETCH_USER_SUCCESS,
  payload: { ...payload },
});

/**
 * Handle CLEAR_USER Action
 * @returns {Object} object
 */
export const clearSelectedUser = () => ({
  type: CLEAR_USER,
});

/**
 * Handle SAVE_USER_REQUEST Action
 * @param {Object} data data
 * @returns {Object} object
 */
export const saveUser = (data) => ({
  type: SAVE_USER_REQUEST,
  payload: { ...data },
});

/**
 * Handle SAVE_USER_SUCCESS Action
 * @param {Object} payload payload
 * @returns {Object} object
 */
export const saveUserSuccess = (payload) => ({
  type: SAVE_USER_SUCCESS,
  payload: { ...payload },
});

/**
 * Handle CONFIGURATION_USERS_FETCH_ACCESS_DATA Action
 * @param {Object} payload payload
 * @returns {Object} object
 */
export const onFetchUserAccessData = (payload) => ({
  type: CONFIGURATION_USERS_FETCH_ACCESS_DATA,
  id: payload.id,
});

/**
 * Fetch success
 * @param  {Object} payload payload
 * @return {Object} object
 */
export const fetchUserAccessDataSuccess = (payload) => ({
  type: CONFIGURATION_USERS_FETCH_ACCESS_SUCCESS,
  payload,
});

/**
 * Handle SAVE_PERMISSIONS_REQUEST Action
 * @param {Object} data data
 * @returns {Object} object
 */
export const savePermissions = (data) => ({
  type: SAVE_PERMISSIONS_REQUEST,
  payload: data,
});

/**
 * Handle SAVE_PERMISSIONS_SUCCESS Action
 * @param {Object} payload payload
 * @returns {Object} object
 */
export const savePermissionsSuccess = (payload) => ({
  type: SAVE_PERMISSIONS_SUCCESS,
  payload,
});

/**
 * Handles FETCH_IMPERSONATE_TOKEN Action
 * @param {number} id id
 * @returns {Object} object
 */
export const fetchImpersonateToken = (id) => ({
  type: FETCH_IMPERSONATE_TOKEN,
  id,
});

/**
 * Handles FETCH_IMPERSONATE_TOKEN_SUCCESS Action
 * @param {Object} token token
 * @returns {Object} object
 */
export const fetchImpersonateTokenSuccess = (token) => ({
  type: FETCH_IMPERSONATE_TOKEN_SUCCESS,
  token,
});

/**
 * Handles CLEAR_LOADING Action
 * @returns {Object} object
 */
export const clearLoading = () => ({
  type: CLEAR_LOADING,
});

/**
 * Handles ACTIVATE_USER_REQUEST Action
 * @param {Object} activation activation
 * @returns {Object} object
 */
export const activateUser = (activation) => ({
  type: ACTIVATE_USER_REQUEST,
  activation,
});

/**
 * Handles ACTIVATE_USER_SUCCESS Action
 * @param {Object} activation activation
 * @returns {Object} object
 */
export const activateUserSuccess = () => ({
  type: ACTIVATE_USER_SUCCESS,
});

/**
 * Handles UPLOAD_USER_DOCUMENT_REQUEST action
 * @param {Object} file file
 * @returns {Object} object
 */
export const uploadUserDocument = (file) => ({
  type: UPLOAD_USER_DOCUMENT_REQUEST,
  payload: {
    file,
  },
});

/**
 * Handles UPLOAD_USER_DOCUMENT_SUCCESS action
 * @returns {Object} object
 */
export const uploadUserDocumentSuccess = () => ({
  type: UPLOAD_USER_DOCUMENT_SUCCESS,
});

/**
 * Handle SAVE_USER_REQUEST Action
 * @param {Object} data data
 * @returns {Object} object
 */
export const resetUserPassword = (data) => ({
  type: RESET_USER_PASSWORD,
  payload: { ...data },
});

/**
 * Handle SAVE_USER_SUCCESS Action
 * @param {Object} payload payload
 * @returns {Object} object
 */
export const resetUserPasswordSuccess = (payload) => ({
  type: RESET_USER_PASSWORD_SUCCESS,
  payload: { ...payload },
});

/**
 * Handle SAVE_USER_REQUEST Action
 * @param {Object} data data
 * @returns {Object} object
 */
export const changeUserPassword = (data) => ({
  type: CHANGE_USER_PASSWORD,
  payload: { ...data },
});

/**
 * Handle SAVE_USER_SUCCESS Action
 * @param {Object} payload payload
 * @returns {Object} object
 */
export const changeUserPasswordSuccess = (payload) => ({
  type: CHANGE_USER_PASSWORD_SUCCESS,
  payload: { ...payload },
});

/**
 * Handle FETCH_USER_GRANT_REQUEST Action
 * @param {Object} payload payload
 * @returns {Object} object
 */
export const fetchUserGrant = (payload) => ({
  type: FETCH_USER_GRANT_REQUEST,
  id: payload.id,
});

/**
 * Handle FETCH_USER_GRANT_REQUEST_SUCCESS Action
 * @param {Object} payload payload
 * @returns {Object} object
 */
export const fetchUserGrantSuccess = (payload) => ({
  type: FETCH_USER_GRANT_REQUEST_SUCCESS,
  payload: { ...payload },
});

/**
 * Handle SAVE_USERS_GRANTS_REQUEST Action
 * @param {Object} data data
 * @returns {Object} object
 */
export const saveUserGrants = (data) => ({
  type: SAVE_USERS_GRANTS_REQUEST,
  payload: { ...data },
});

/**
 * Handle SAVE_USERS_GRANTS_REQUEST_SUCCESS Action
 * @param {Object} payload payload
 * @returns {Object} object
 */
export const saveUserGrantsSuccess = (payload) => ({
  type: SAVE_USERS_GRANTS_REQUEST_SUCCESS,
  payload: { ...payload },
});

/**
 * Handle FETCH_UPLOAD_LOGS_REQUEST Action
 * @param {*} payload payload
 * @returns {object} object
 */
export const fetchUploadLogsRequest = (payload) => ({
  type: FETCH_UPLOAD_LOGS_REQUEST,
  payload,
});

/**
 * Handle FETCH_UPLOAD_LOGS_SUCCESS Action
 * @param {*} payload payload
 * @returns {object} object
 */
export const fetchUploadLogsSuccess = (payload) => ({
  type: FETCH_UPLOAD_LOGS_SUCCESS,
  payload,
});

/**
 * Handle FETCH_DETAILED_REPORT_REQUEST Action
 * @param {object} payload payload
 * @returns {object} object
 */
export const fetchDetailedReportRequest = (payload) => ({
  type: FETCH_DETAILED_REPORT_REQUEST,
  payload,
});

/**
 * getUserProgramsListing Action Creator
 * @param {number} page Page Number
 * @param {string} sorting Sorting String
 * @param {string} filter Filter String
 * @param {Number} size Elements per page
 * @param {string} userId Current user ID
 * @returns {object} Action Type, Page Number, Sorting String, Filter String
 */
export const getUserProgramsListing = (page, sorting, filter, size, userId) => ({
  type: USER_PROGRAMS_LISTING_REQUEST,
  page,
  sorting,
  filter,
  size,
  userId,
});

/**
 * Handle USER_PROGRAMS_LISTING_SUCCESS Action
 * @param {Object} payload data payload
 * @returns {Object} payload
 */
export const getUserProgramsListingSuccess = (payload) => ({
  type: USER_PROGRAMS_LISTING_SUCCESS,
  payload,
});

/**
 * Resets user programs listing.
 * @returns {Object} object
 */
export const resetUserProgramsListing = () => ({
  type: USER_PROGRAMS_LISTING_RESET,
});

/**
 * getExcludedFacilities Action Creator
 * @param {number} page Page Number
 * @param {string} sorting Sorting String
 * @param {string} filter Filter String
 * @param {Number} size Elements per page
 * @param {string} programId Current program ID
 * @returns {object} Action Type, Page Number, Sorting String, Filter String
 */
export const getExcludedFacilities = (page, sorting, filter, size, programId) => ({
  type: EXCLUDED_FACILITIES_REQUEST,
  page,
  sorting,
  filter,
  size,
  programId,
});

/**
 * Handle getExcludedFacilitiesSuccess Action
 * @param {Object} payload data payload
 * @returns {Object} payload
 */
export const getExcludedFacilitiesSuccess = (payload) => ({
  type: EXCLUDED_FACILITIES_SUCCESS,
  payload,
});

/**
 * getUserPreferences Action Creator
 * @returns {{type: string}} Action Type
 */
export const getUserPreferences = () => ({
  type: FETCH_USER_PREFERENCES_REQUEST,
});

/**
 * getUserPreferencesSuccess Action Creator
 * @param {object} payload Action Payload
 * @returns {{payload, type: string}} Action Type, Payload
 */
export const getUserPreferencesSuccess = (payload) => ({
  type: FETCH_USER_PREFERENCES_SUCCESS,
  payload,
});

/**
 * saveUserPreferences Action Creator
 * @param {object} payload Action Payload
 * @returns {{payload, type: string}} Action Type, Payload
 */
export const saveUserPreferences = (payload) => ({
  type: SAVE_USER_PREFERENCES_REQUEST,
  payload,
});

/**
 * saveUserPreferencesSuccess Action Creator
 * @param {object} payload Action Payload
 * @returns {{payload, type: string}} Action Type, Payload
 */
export const saveUserPreferencesSuccess = (payload) => ({
  type: SAVE_USER_PREFERENCES_SUCCESS,
  payload,
});
